const Tags = () => import("Modules/tags/views/Tags");
const TagsForm = () => import("Modules/tags/views/TagsForm");

export default {
    children: [
        {
            path: "tags",
            name: "tags",
            component: Tags,
            meta: {
                requiresAuth: true,
                title: "lang.tags",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: ["tags.read"],
            },
        },
        {
            path: "tag/:id?",
            name: "tag",
            component: TagsForm,
            meta: {
                requiresAuth: true,
                title: "lang.tags",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: ["tags.read"],
            },
        },
    ],
};
